import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';

import { SETTINGS_API_URL } from '../../utils/constants/ApiConstants';
import { httpService } from '../fetch/HttpService';

export const putLanguageData = async (key: string, value: string) => {
  const headers = [
    HTTP_HEADER_KEYS.DEVICE_ID,
    HTTP_HEADER_KEYS.ESK,
    HTTP_HEADER_KEYS.CONTENT_TYPE,
    HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN
  ];

  const reqBody = {
    key,
    value
  };

  return httpService.fetchApiData({
    url: SETTINGS_API_URL,
    type: HTTP_METHODS.PUT,
    body: reqBody,
    headers
  });
};

export const postSettingsData = async (key: string, value: string) => {
  const headers = [
    HTTP_HEADER_KEYS.DEVICE_ID,
    HTTP_HEADER_KEYS.ESK,
    HTTP_HEADER_KEYS.CONTENT_TYPE
  ];

  const reqBody = {
    key,
    value
  };

  return httpService.fetchApiData({
    url: SETTINGS_API_URL,
    type: HTTP_METHODS.POST,
    body: reqBody,
    headers
  });
};
